// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   BOOKVENUE — HEADER (Theme-driven, fully responsive)
   ================================================================ */

body a { text-decoration: none; }

/* ---- Overlay (used by login modal, etc) ---- */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

/* ===== TOP NAV ==================================================== */
.bv-site-nav-wrap {
  padding: 0 var(--bv-container-px) 0;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  position: sticky;
  top: 0;
  z-index: var(--bv-z-nav);
  overflow: visible;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);
}

.bv-site-nav {
  max-width: var(--bv-container-wide);
  margin: 0 auto;
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  column-gap: 20px;
  min-height: 88px;
  padding: 0px 4px 0px;
  overflow: visible;
}

.bv-site-nav__start,
.bv-site-nav__end {
  display: flex;
  align-items: center;
  min-width: 0;
}

.bv-site-nav__start {
  justify-content: flex-start;
}

.bv-site-nav__end {
  justify-content: flex-end;
}

.bv-site-nav__center {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  pointer-events: none;
}

.bv-site-nav__center .bv-brand {
  pointer-events: auto;
}

/* ---- Brand (centered, wide logo) ---- */
.bv-brand {
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
  flex-shrink: 0;
  cursor: pointer;
  line-height: 0;
}

.bv-brand__logo {
  display: block;
  width: clamp(200px, 24vw, 360px);
  height: auto;
  max-height: 72px;
  object-fit: contain;
  object-position: center;
}

/* ---- Desktop nav (left) ---- */
.bv-site-nav__desk {
  display: flex;
  align-items: center;
  gap: 4px;
}

.bv-site-nav__drawer {
  display: none;
}
.bv-nav-link {
  border: none;
  background: transparent;
  color: var(--bv-ink-2);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  font-weight: 500;
  border-radius: var(--bv-radius-pill);
  padding: 9px 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background var(--bv-dur) var(--bv-ease), color var(--bv-dur) var(--bv-ease);
}
.bv-nav-link i {
  color: var(--bv-muted);
  font-size: 0.82rem;
  transition: color var(--bv-dur) var(--bv-ease);
}
.bv-nav-link:hover,
.bv-nav-link.active {
  color: var(--bv-primary-700);
  background: var(--bv-primary-50);
}
.bv-nav-link:hover i,
.bv-nav-link.active i { color: var(--bv-primary); }

/* ---- Right side actions ---- */
.bv-site-nav__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  overflow: visible;
}
.bv-action-btn,
.bv-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: var(--bv-bg-soft);
  color: var(--bv-ink-2);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background var(--bv-dur) var(--bv-ease), color var(--bv-dur) var(--bv-ease);
}
.bv-action-btn:hover,
.bv-avatar:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
}
.bv-avatar:not(button) {
  background: var(--bv-grad-primary);
  color: #fff;
}

.bv-wallet {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border-radius: var(--bv-radius-pill);
  border: 1px solid var(--bv-primary-line);
  background: var(--bv-grad-soft);
  color: var(--bv-primary-700);
  font-size: 0.82rem;
  font-weight: 700;
}
.bv-login-btn {
  position: relative;
  border: 1.5px solid var(--bv-primary-line);
  background: var(--bv-grad-soft);
  color: var(--bv-primary-700);
  border-radius: var(--bv-radius-pill);
  padding: 10px 18px 10px 10px;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  font-weight: 500;
  letter-spacing: 0.01em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: border-color var(--bv-dur) var(--bv-ease),
              background var(--bv-dur) var(--bv-ease),
              transform var(--bv-dur) var(--bv-ease),
              box-shadow var(--bv-dur) var(--bv-ease),
              color var(--bv-dur) var(--bv-ease);
}
.bv-login-btn__icon {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--bv-text-sm);
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(20, 184, 166, 0.30);
  transition: transform var(--bv-dur) var(--bv-ease);
}
.bv-login-btn:hover {
  border-color: var(--bv-primary);
  background: #fff;
  color: var(--bv-primary-700);
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(20, 184, 166, 0.18);
}
.bv-login-btn:hover .bv-login-btn__icon { transform: scale(1.08); }
.bv-list-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 8px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-primary-line);
  background: var(--bv-grad-soft);
  color: var(--bv-primary-700);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: transform var(--bv-dur) var(--bv-ease),
              box-shadow var(--bv-dur) var(--bv-ease),
              border-color var(--bv-dur) var(--bv-ease),
              background var(--bv-dur) var(--bv-ease),
              color var(--bv-dur) var(--bv-ease);
  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.14);
  text-decoration: none;
}
.bv-list-btn__icon {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--bv-grad-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--bv-text-sm);
  color: #fff;
  flex-shrink: 0;
  transition: transform var(--bv-dur) var(--bv-ease);
}
.bv-list-btn__text { white-space: nowrap; }
.bv-list-btn:hover {
  transform: translateY(-2px);
  border-color: var(--bv-primary);
  background: #fff;
  box-shadow: 0 12px 28px rgba(20, 184, 166, 0.2);
  color: var(--bv-primary-700);
}
.bv-list-btn:hover .bv-list-btn__icon { transform: rotate(90deg); }

/* ---- User profile dropdown ---- */
.bv-user-dropdown {
  position: relative;
  flex-shrink: 0;
}
.bv-user-trigger {
  border: 1.5px solid var(--bv-primary-line);
  background: var(--bv-grad-soft);
  color: var(--bv-primary-700);
  border-radius: var(--bv-radius-pill);
  padding: 6px 14px 6px 6px;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-base);
  font-weight: 500;
  letter-spacing: 0.01em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.14);
  transition:
    border-color var(--bv-dur) var(--bv-ease),
    box-shadow var(--bv-dur) var(--bv-ease),
    background var(--bv-dur) var(--bv-ease),
    transform var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}
.bv-user-trigger:hover,
.bv-user-trigger.is-open {
  border-color: var(--bv-primary);
  background: #fff;
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(20, 184, 166, 0.2);
  color: var(--bv-primary-700);
}
.bv-user-trigger__avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--bv-grad-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bv-font-display);
  font-size: 0.72rem;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 10px rgba(20, 184, 166, 0.30);
}
.bv-user-trigger__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.bv-user-trigger__text {
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1;
}
.bv-user-trigger__chev {
  font-size: 0.6rem;
  color: var(--bv-primary-700);
  opacity: 0.7;
  flex-shrink: 0;
  transition: transform var(--bv-dur) var(--bv-ease);
}
.bv-user-trigger.is-open .bv-user-trigger__chev {
  transform: rotate(180deg);
  opacity: 1;
}

.bv-user-dropdown__panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  left: auto;
  width: 220px;
  z-index: 60;
  transform-origin: top right;
  animation: bvUserMenuIn 0.2s var(--bv-ease-out) both;
}
@keyframes bvUserMenuIn {
  from { opacity: 0; transform: translateY(-6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.bv-user-menu {
  background: #fff;
  border: 1px solid var(--bv-primary-line);
  border-radius: var(--bv-radius);
  box-shadow: var(--bv-shadow-md);
  overflow: hidden;
}
.bv-user-menu__head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--bv-grad-soft);
  border-bottom: 1px solid var(--bv-line-soft);
}
.bv-user-menu__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--bv-grad-primary);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 700;
  flex-shrink: 0;
}
.bv-user-menu__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.bv-user-menu__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.bv-user-menu__meta strong {
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-sm);
  font-weight: 600;
  color: var(--bv-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bv-user-menu__meta span {
  font-size: 0.68rem;
  color: var(--bv-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bv-user-menu__links {
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
}
.bv-user-menu__link {
  width: 100%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: var(--bv-radius-sm);
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 500;
  color: var(--bv-ink-2);
  text-align: left;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    color var(--bv-dur) var(--bv-ease);
}
.bv-user-menu__link i:first-child {
  width: 16px;
  text-align: center;
  color: var(--bv-primary);
  font-size: 0.78rem;
}
.bv-user-menu__link-arrow { display: none; }
.bv-user-menu__link:hover {
  background: var(--bv-primary-50);
  color: var(--bv-primary-800);
}
.bv-user-menu__logout {
  width: calc(100% - 12px);
  margin: 2px 6px 8px;
  border: 1px solid rgba(239, 68, 68, 0.16);
  background: rgba(254, 242, 242, 0.6);
  color: #dc2626;
  border-radius: var(--bv-radius-sm);
  padding: 8px 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: var(--bv-font-body);
  font-size: var(--bv-text-sm);
  font-weight: 500;
  cursor: pointer;
  transition:
    background var(--bv-dur) var(--bv-ease),
    border-color var(--bv-dur) var(--bv-ease);
}
.bv-user-menu__logout:hover {
  background: #fef2f2;
  border-color: rgba(239, 68, 68, 0.3);
}

.bv-user-menu--mobile {
  border: 1px solid var(--bv-primary-line);
  border-radius: var(--bv-radius);
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: var(--bv-shadow-sm);
}

/* Mobile toggle button (hidden on desktop) */
.bv-mobile-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1.5px solid var(--bv-primary-line);
  background: var(--bv-primary-50);
  color: var(--bv-primary-700);
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background var(--bv-dur) var(--bv-ease),
              color var(--bv-dur) var(--bv-ease),
              transform var(--bv-dur) var(--bv-ease);
}
.bv-mobile-toggle:hover {
  background: var(--bv-primary);
  color: #fff;
}
.bv-site-nav__drawer-actions { display: none; }
.bv-nav-menu-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  border-radius: var(--bv-radius-pill);
  border: 1.5px solid var(--bv-line);
  background: #fff;
  color: var(--bv-ink-2);
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-base);
  font-weight: 700;
  cursor: pointer;
  transition: background var(--bv-dur) var(--bv-ease), border-color var(--bv-dur) var(--bv-ease);
}
.bv-nav-menu-btn--ghost:hover {
  background: var(--bv-bg-soft);
  border-color: var(--bv-primary-line);
  color: var(--bv-primary-700);
}

/* ===== RESPONSIVE ================================================ */
@media (max-width: 1200px) {
  .bv-nav-link span { display: none; }
  .bv-login-btn__label { display: none; }
  .bv-user-trigger__text { display: none; }
  .bv-user-trigger {
    padding: 6px 8px 6px 6px;
    border-radius: var(--bv-radius-pill);
  }
  .bv-user-trigger__chev { display: none; }
}

@media (max-width: 992px) {
  .bv-site-nav-wrap {
    position: sticky;
    top: 0;
    z-index: var(--bv-z-nav);
    padding: 0 var(--bv-container-px);
    overflow: visible;
  }

  .bv-site-nav {
    position: relative;
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto;
    align-items: center;
    column-gap: 10px;
    row-gap: 6px;
    padding: 8px 0;
    min-height: 60px;
    overflow: visible;
  }

  .bv-site-nav__start {
    display: none;
  }

  .bv-site-nav__desk {
    display: none;
  }

  .bv-site-nav__center {
    grid-column: 1;
    grid-row: 1;
    justify-self: start;
    min-width: 0;
    max-width: 100%;
    pointer-events: auto;
  }

  .bv-brand {
    max-width: 100%;
    justify-content: flex-start;
    padding: 2px 0;
  }

  .bv-brand__logo {
    width: clamp(132px, 38vw, 200px);
    max-height: 46px;
    height: auto;
  }

  .bv-site-nav__end {
    grid-column: 3;
    grid-row: 1;
    justify-self: end;
    flex-shrink: 0;
  }

  .bv-site-nav__drawer {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  .bv-site-nav__actions {
    gap: 6px;
    flex-shrink: 0;
  }
  .bv-list-btn--bar { display: none; }
  .bv-user-dropdown { display: none; }
  .bv-login-btn--bar {
    display: inline-flex;
    padding: 6px 8px 6px 6px;
  }
  .bv-login-btn--bar .bv-login-btn__label { display: none; }
  .bv-mobile-toggle { display: inline-flex; }

  /* Slide-down menu panel — full width, flush edges */
  .bv-site-nav__drawer {
    display: none;
    position: absolute;
    top: 100%;
    left: calc(-1 * var(--bv-container-px));
    right: calc(-1 * var(--bv-container-px));
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 0;
    background: #fff;
    border: none;
    border-top: 1px solid var(--bv-line);
    border-bottom: 1px solid var(--bv-line);
    border-radius: 0;
    box-shadow: 0 14px 36px rgba(15, 23, 42, 0.12);
    z-index: 50;
    animation: bvNavDrop 0.22s var(--bv-ease-out) both;
  }

  .bv-site-nav__drawer.is-open { display: flex; }
  @keyframes bvNavDrop {
    from { opacity: 0; transform: translateY(-8px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .bv-site-nav__drawer-links {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px var(--bv-container-px) 6px;
  }
  .bv-nav-link {
    width: 100%;
    flex: none;
    justify-content: flex-start;
    padding: 12px 14px;
    font-size: 0.875rem;
    font-weight: 600;
    border-radius: var(--bv-radius);
  }
  .bv-nav-link span { display: inline; }
  .bv-nav-link i {
    width: 20px;
    text-align: center;
    font-size: 0.9rem;
  }

  .bv-site-nav__drawer-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 0;
    padding: 8px var(--bv-container-px) 25px;
    border-top: 1px solid var(--bv-line-soft);
  }

  .bv-user-menu--mobile {
    border: none;
    border-radius: 0;
    margin-bottom: 0;
    box-shadow: none;
  }

  .bv-site-nav__drawer-footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .bv-drawer-footer-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 8px 10px;
    border-radius: var(--bv-radius);
    border: 1px solid var(--bv-line);
    background: #fff;
    font-family: var(--bv-font-body);
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
    text-decoration: none;
    cursor: pointer;
    transition:
      background var(--bv-dur) var(--bv-ease),
      border-color var(--bv-dur) var(--bv-ease),
      color var(--bv-dur) var(--bv-ease);
  }

  .bv-drawer-footer-btn i {
    font-size: 0.72rem;
    flex-shrink: 0;
  }

  .bv-drawer-footer-btn span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bv-drawer-footer-btn--login {
    color: var(--bv-primary-800);
    border-color: var(--bv-primary-line);
    background: var(--bv-primary-50);
  }

  .bv-drawer-footer-btn--login:hover {
    background: #fff;
    border-color: var(--bv-primary);
  }

  .bv-drawer-footer-btn--logout {
    color: #dc2626;
    border-color: rgba(239, 68, 68, 0.2);
    background: #fef2f2;
  }

  .bv-drawer-footer-btn--logout:hover {
    background: #fee2e2;
    border-color: rgba(239, 68, 68, 0.35);
  }

  .bv-drawer-footer-btn--list {
    color: var(--bv-primary-800);
    border-color: var(--bv-primary-line);
    background: var(--bv-bg-soft);
  }

  .bv-drawer-footer-btn--list:hover {
    background: var(--bv-primary-50);
    border-color: var(--bv-primary);
    color: var(--bv-primary-800);
  }
}

@media (max-width: 600px) {
  .bv-site-nav-wrap {
    padding: 0 12px;
  }

  .bv-site-nav {
    padding: 6px 0;
    column-gap: 8px;
    min-height: 56px;
  }

  .bv-brand__logo {
    width: clamp(120px, 44vw, 168px);
    max-height: 70px;
    height: auto;
  }

  .bv-mobile-toggle {
    width: 36px;
    height: 36px;
    font-size: 0.85rem;
  }

  .bv-login-btn--bar {
    padding: 5px 6px 5px 5px;
  }

  .bv-site-nav__drawer {
    left: -12px;
    right: -12px;
  }

  .bv-site-nav__drawer-links {
    padding-inline: 12px;
  }

  .bv-site-nav__drawer-actions {
    padding-inline: 12px;
  }

  .bv-drawer-footer-btn {
    min-height: 34px;
    padding: 7px 8px;
    font-size: 0.7rem;
    gap: 5px;
  }

  .bv-nav-link {
    padding: 11px 12px;
    font-size: 0.875rem;
  }
}

/* ===== LEGACY SUPPORT (header used elsewhere in site) ============ */
.search-box { position: relative; }
.suggestionList {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  background: #fff;
  border-radius: var(--bv-radius);
  box-shadow: var(--bv-shadow);
  padding: 8px;
}
.search-box .form-control:focus {
  box-shadow: none !important;
  border-color: var(--bv-line) !important;
}
.search-box .input-group-text,
.search-box .form-control {
  border: 0 !important;
  background: transparent !important;
}
`, "",{"version":3,"sources":["webpack://./src/css/header.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE,SAAS,qBAAqB,EAAE;;AAEhC,iDAAiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA,uEAAuE;AACvE;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,gBAAgB;EAChB,MAAM;EACN,wBAAwB;EACxB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uFAAuF;AACzF;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;;EAEE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;wBACwB,wBAAwB,EAAE;;AAElD,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uFAAuF;AACzF;AACA;;EAEE,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;EACpC,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR;;;;gDAI8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,+CAA+C;EAC/C,kDAAkD;AACpD;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,gDAAgD;AAClD;AACA,0CAA0C,sBAAsB,EAAE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB;;;;gDAI8C;EAC9C,+CAA+C;EAC/C,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,cAAc;EACd,kDAAkD;AACpD;AACA,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;EAC/C,4BAA4B;AAC9B;AACA,wCAAwC,wBAAwB,EAAE;;AAElE,oCAAoC;AACpC;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,+CAA+C;EAC/C;;;;;sCAKoC;AACtC;AACA;;EAEE,+BAA+B;EAC/B,gBAAgB;EAChB,2BAA2B;EAC3B,+CAA+C;EAC/C,4BAA4B;AAC9B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,YAAY;EACZ,cAAc;EACd,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,oDAAoD;AACtD;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf;;sCAEoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;AACA,4BAA4B,aAAa,EAAE;AAC3C;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf;;6CAE2C;AAC7C;AACA;EACE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,gCAAgC;EAChC,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd;;oDAEkD;AACpD;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA,+BAA+B,aAAa,EAAE;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,8FAA8F;AAChG;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA,sEAAsE;AACtE;EACE,oBAAoB,aAAa,EAAE;EACnC,uBAAuB,aAAa,EAAE;EACtC,yBAAyB,aAAa,EAAE;EACxC;IACE,wBAAwB;IACxB,oCAAoC;EACtC;EACA,yBAAyB,aAAa,EAAE;AAC1C;;AAEA;EACE;IACE,gBAAgB;IAChB,MAAM;IACN,wBAAwB;IACxB,iCAAiC;IACjC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,cAAc;EAChB;EACA,oBAAoB,aAAa,EAAE;EACnC,oBAAoB,aAAa,EAAE;EACnC;IACE,oBAAoB;IACpB,wBAAwB;EAC1B;EACA,0CAA0C,aAAa,EAAE;EACzD,oBAAoB,oBAAoB,EAAE;;EAE1C,oDAAoD;EACpD;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,uCAAuC;IACvC,wCAAwC;IACxC,sBAAsB;IACtB,oBAAoB;IACpB,MAAM;IACN,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,oCAAoC;IACpC,uCAAuC;IACvC,gBAAgB;IAChB,8CAA8C;IAC9C,WAAW;IACX,kDAAkD;EACpD;;EAEA,+BAA+B,aAAa,EAAE;EAC9C;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC/C;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uCAAuC;EACzC;EACA;IACE,WAAW;IACX,UAAU;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;EACjC;EACA,oBAAoB,eAAe,EAAE;EACrC;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,wCAAwC;IACxC,yCAAyC;EAC3C;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf;;;wCAGoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qCAAqC;EACvC;;EAEA;IACE,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;IAChC,+BAA+B;IAC/B,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,sEAAsE;AACtE,cAAc,kBAAkB,EAAE;AAClC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;AACA;;EAEE,oBAAoB;EACpB,kCAAkC;AACpC","sourcesContent":["/* ================================================================\n   BOOKVENUE — HEADER (Theme-driven, fully responsive)\n   ================================================================ */\n\nbody a { text-decoration: none; }\n\n/* ---- Overlay (used by login modal, etc) ---- */\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n/* ===== TOP NAV ==================================================== */\n.bv-site-nav-wrap {\n  padding: 0 var(--bv-container-px) 0;\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  position: sticky;\n  top: 0;\n  z-index: var(--bv-z-nav);\n  overflow: visible;\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.06);\n}\n\n.bv-site-nav {\n  max-width: var(--bv-container-wide);\n  margin: 0 auto;\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: center;\n  column-gap: 20px;\n  min-height: 88px;\n  padding: 0px 4px 0px;\n  overflow: visible;\n}\n\n.bv-site-nav__start,\n.bv-site-nav__end {\n  display: flex;\n  align-items: center;\n  min-width: 0;\n}\n\n.bv-site-nav__start {\n  justify-content: flex-start;\n}\n\n.bv-site-nav__end {\n  justify-content: flex-end;\n}\n\n.bv-site-nav__center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-self: center;\n  pointer-events: none;\n}\n\n.bv-site-nav__center .bv-brand {\n  pointer-events: auto;\n}\n\n/* ---- Brand (centered, wide logo) ---- */\n.bv-brand {\n  border: none;\n  background: transparent;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px 0;\n  flex-shrink: 0;\n  cursor: pointer;\n  line-height: 0;\n}\n\n.bv-brand__logo {\n  display: block;\n  width: clamp(200px, 24vw, 360px);\n  height: auto;\n  max-height: 72px;\n  object-fit: contain;\n  object-position: center;\n}\n\n/* ---- Desktop nav (left) ---- */\n.bv-site-nav__desk {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.bv-site-nav__drawer {\n  display: none;\n}\n.bv-nav-link {\n  border: none;\n  background: transparent;\n  color: var(--bv-ink-2);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  font-weight: 500;\n  border-radius: var(--bv-radius-pill);\n  padding: 9px 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: background var(--bv-dur) var(--bv-ease), color var(--bv-dur) var(--bv-ease);\n}\n.bv-nav-link i {\n  color: var(--bv-muted);\n  font-size: 0.82rem;\n  transition: color var(--bv-dur) var(--bv-ease);\n}\n.bv-nav-link:hover,\n.bv-nav-link.active {\n  color: var(--bv-primary-700);\n  background: var(--bv-primary-50);\n}\n.bv-nav-link:hover i,\n.bv-nav-link.active i { color: var(--bv-primary); }\n\n/* ---- Right side actions ---- */\n.bv-site-nav__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n  overflow: visible;\n}\n.bv-action-btn,\n.bv-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: none;\n  background: var(--bv-bg-soft);\n  color: var(--bv-ink-2);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: background var(--bv-dur) var(--bv-ease), color var(--bv-dur) var(--bv-ease);\n}\n.bv-action-btn:hover,\n.bv-avatar:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n}\n.bv-avatar:not(button) {\n  background: var(--bv-grad-primary);\n  color: #fff;\n}\n\n.bv-wallet {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 12px;\n  border-radius: var(--bv-radius-pill);\n  border: 1px solid var(--bv-primary-line);\n  background: var(--bv-grad-soft);\n  color: var(--bv-primary-700);\n  font-size: 0.82rem;\n  font-weight: 700;\n}\n.bv-login-btn {\n  position: relative;\n  border: 1.5px solid var(--bv-primary-line);\n  background: var(--bv-grad-soft);\n  color: var(--bv-primary-700);\n  border-radius: var(--bv-radius-pill);\n  padding: 10px 18px 10px 10px;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: border-color var(--bv-dur) var(--bv-ease),\n              background var(--bv-dur) var(--bv-ease),\n              transform var(--bv-dur) var(--bv-ease),\n              box-shadow var(--bv-dur) var(--bv-ease),\n              color var(--bv-dur) var(--bv-ease);\n}\n.bv-login-btn__icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--bv-text-sm);\n  flex-shrink: 0;\n  box-shadow: 0 4px 10px rgba(20, 184, 166, 0.30);\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n.bv-login-btn:hover {\n  border-color: var(--bv-primary);\n  background: #fff;\n  color: var(--bv-primary-700);\n  transform: translateY(-2px);\n  box-shadow: 0 10px 26px rgba(20, 184, 166, 0.18);\n}\n.bv-login-btn:hover .bv-login-btn__icon { transform: scale(1.08); }\n.bv-list-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px 8px 8px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-primary-line);\n  background: var(--bv-grad-soft);\n  color: var(--bv-primary-700);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  transition: transform var(--bv-dur) var(--bv-ease),\n              box-shadow var(--bv-dur) var(--bv-ease),\n              border-color var(--bv-dur) var(--bv-ease),\n              background var(--bv-dur) var(--bv-ease),\n              color var(--bv-dur) var(--bv-ease);\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.14);\n  text-decoration: none;\n}\n.bv-list-btn__icon {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--bv-grad-primary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--bv-text-sm);\n  color: #fff;\n  flex-shrink: 0;\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n.bv-list-btn__text { white-space: nowrap; }\n.bv-list-btn:hover {\n  transform: translateY(-2px);\n  border-color: var(--bv-primary);\n  background: #fff;\n  box-shadow: 0 12px 28px rgba(20, 184, 166, 0.2);\n  color: var(--bv-primary-700);\n}\n.bv-list-btn:hover .bv-list-btn__icon { transform: rotate(90deg); }\n\n/* ---- User profile dropdown ---- */\n.bv-user-dropdown {\n  position: relative;\n  flex-shrink: 0;\n}\n.bv-user-trigger {\n  border: 1.5px solid var(--bv-primary-line);\n  background: var(--bv-grad-soft);\n  color: var(--bv-primary-700);\n  border-radius: var(--bv-radius-pill);\n  padding: 6px 14px 6px 6px;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-base);\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  box-shadow: 0 8px 20px rgba(20, 184, 166, 0.14);\n  transition:\n    border-color var(--bv-dur) var(--bv-ease),\n    box-shadow var(--bv-dur) var(--bv-ease),\n    background var(--bv-dur) var(--bv-ease),\n    transform var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n.bv-user-trigger:hover,\n.bv-user-trigger.is-open {\n  border-color: var(--bv-primary);\n  background: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px rgba(20, 184, 166, 0.2);\n  color: var(--bv-primary-700);\n}\n.bv-user-trigger__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--bv-font-display);\n  font-size: 0.72rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  box-shadow: 0 4px 10px rgba(20, 184, 166, 0.30);\n}\n.bv-user-trigger__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.bv-user-trigger__text {\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: 1;\n}\n.bv-user-trigger__chev {\n  font-size: 0.6rem;\n  color: var(--bv-primary-700);\n  opacity: 0.7;\n  flex-shrink: 0;\n  transition: transform var(--bv-dur) var(--bv-ease);\n}\n.bv-user-trigger.is-open .bv-user-trigger__chev {\n  transform: rotate(180deg);\n  opacity: 1;\n}\n\n.bv-user-dropdown__panel {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  left: auto;\n  width: 220px;\n  z-index: 60;\n  transform-origin: top right;\n  animation: bvUserMenuIn 0.2s var(--bv-ease-out) both;\n}\n@keyframes bvUserMenuIn {\n  from { opacity: 0; transform: translateY(-6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.bv-user-menu {\n  background: #fff;\n  border: 1px solid var(--bv-primary-line);\n  border-radius: var(--bv-radius);\n  box-shadow: var(--bv-shadow-md);\n  overflow: hidden;\n}\n.bv-user-menu__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  background: var(--bv-grad-soft);\n  border-bottom: 1px solid var(--bv-line-soft);\n}\n.bv-user-menu__avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: var(--bv-grad-primary);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 700;\n  flex-shrink: 0;\n}\n.bv-user-menu__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.bv-user-menu__meta {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.bv-user-menu__meta strong {\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-sm);\n  font-weight: 600;\n  color: var(--bv-ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.bv-user-menu__meta span {\n  font-size: 0.68rem;\n  color: var(--bv-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.bv-user-menu__links {\n  display: flex;\n  flex-direction: column;\n  padding: 6px;\n  gap: 2px;\n}\n.bv-user-menu__link {\n  width: 100%;\n  border: none;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-radius: var(--bv-radius-sm);\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  color: var(--bv-ink-2);\n  text-align: left;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    color var(--bv-dur) var(--bv-ease);\n}\n.bv-user-menu__link i:first-child {\n  width: 16px;\n  text-align: center;\n  color: var(--bv-primary);\n  font-size: 0.78rem;\n}\n.bv-user-menu__link-arrow { display: none; }\n.bv-user-menu__link:hover {\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-800);\n}\n.bv-user-menu__logout {\n  width: calc(100% - 12px);\n  margin: 2px 6px 8px;\n  border: 1px solid rgba(239, 68, 68, 0.16);\n  background: rgba(254, 242, 242, 0.6);\n  color: #dc2626;\n  border-radius: var(--bv-radius-sm);\n  padding: 8px 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-family: var(--bv-font-body);\n  font-size: var(--bv-text-sm);\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background var(--bv-dur) var(--bv-ease),\n    border-color var(--bv-dur) var(--bv-ease);\n}\n.bv-user-menu__logout:hover {\n  background: #fef2f2;\n  border-color: rgba(239, 68, 68, 0.3);\n}\n\n.bv-user-menu--mobile {\n  border: 1px solid var(--bv-primary-line);\n  border-radius: var(--bv-radius);\n  overflow: hidden;\n  margin-bottom: 8px;\n  box-shadow: var(--bv-shadow-sm);\n}\n\n/* Mobile toggle button (hidden on desktop) */\n.bv-mobile-toggle {\n  display: none;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1.5px solid var(--bv-primary-line);\n  background: var(--bv-primary-50);\n  color: var(--bv-primary-700);\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background var(--bv-dur) var(--bv-ease),\n              color var(--bv-dur) var(--bv-ease),\n              transform var(--bv-dur) var(--bv-ease);\n}\n.bv-mobile-toggle:hover {\n  background: var(--bv-primary);\n  color: #fff;\n}\n.bv-site-nav__drawer-actions { display: none; }\n.bv-nav-menu-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  padding: 12px 16px;\n  border-radius: var(--bv-radius-pill);\n  border: 1.5px solid var(--bv-line);\n  background: #fff;\n  color: var(--bv-ink-2);\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-base);\n  font-weight: 700;\n  cursor: pointer;\n  transition: background var(--bv-dur) var(--bv-ease), border-color var(--bv-dur) var(--bv-ease);\n}\n.bv-nav-menu-btn--ghost:hover {\n  background: var(--bv-bg-soft);\n  border-color: var(--bv-primary-line);\n  color: var(--bv-primary-700);\n}\n\n/* ===== RESPONSIVE ================================================ */\n@media (max-width: 1200px) {\n  .bv-nav-link span { display: none; }\n  .bv-login-btn__label { display: none; }\n  .bv-user-trigger__text { display: none; }\n  .bv-user-trigger {\n    padding: 6px 8px 6px 6px;\n    border-radius: var(--bv-radius-pill);\n  }\n  .bv-user-trigger__chev { display: none; }\n}\n\n@media (max-width: 992px) {\n  .bv-site-nav-wrap {\n    position: sticky;\n    top: 0;\n    z-index: var(--bv-z-nav);\n    padding: 0 var(--bv-container-px);\n    overflow: visible;\n  }\n\n  .bv-site-nav {\n    position: relative;\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    grid-template-rows: auto auto;\n    align-items: center;\n    column-gap: 10px;\n    row-gap: 6px;\n    padding: 8px 0;\n    min-height: 60px;\n    overflow: visible;\n  }\n\n  .bv-site-nav__start {\n    display: none;\n  }\n\n  .bv-site-nav__desk {\n    display: none;\n  }\n\n  .bv-site-nav__center {\n    grid-column: 1;\n    grid-row: 1;\n    justify-self: start;\n    min-width: 0;\n    max-width: 100%;\n    pointer-events: auto;\n  }\n\n  .bv-brand {\n    max-width: 100%;\n    justify-content: flex-start;\n    padding: 2px 0;\n  }\n\n  .bv-brand__logo {\n    width: clamp(132px, 38vw, 200px);\n    max-height: 46px;\n    height: auto;\n  }\n\n  .bv-site-nav__end {\n    grid-column: 3;\n    grid-row: 1;\n    justify-self: end;\n    flex-shrink: 0;\n  }\n\n  .bv-site-nav__drawer {\n    grid-column: 1 / -1;\n    grid-row: 2;\n  }\n\n  .bv-site-nav__actions {\n    gap: 6px;\n    flex-shrink: 0;\n  }\n  .bv-list-btn--bar { display: none; }\n  .bv-user-dropdown { display: none; }\n  .bv-login-btn--bar {\n    display: inline-flex;\n    padding: 6px 8px 6px 6px;\n  }\n  .bv-login-btn--bar .bv-login-btn__label { display: none; }\n  .bv-mobile-toggle { display: inline-flex; }\n\n  /* Slide-down menu panel — full width, flush edges */\n  .bv-site-nav__drawer {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: calc(-1 * var(--bv-container-px));\n    right: calc(-1 * var(--bv-container-px));\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0;\n    padding: 0;\n    background: #fff;\n    border: none;\n    border-top: 1px solid var(--bv-line);\n    border-bottom: 1px solid var(--bv-line);\n    border-radius: 0;\n    box-shadow: 0 14px 36px rgba(15, 23, 42, 0.12);\n    z-index: 50;\n    animation: bvNavDrop 0.22s var(--bv-ease-out) both;\n  }\n\n  .bv-site-nav__drawer.is-open { display: flex; }\n  @keyframes bvNavDrop {\n    from { opacity: 0; transform: translateY(-8px); }\n    to   { opacity: 1; transform: translateY(0); }\n  }\n\n  .bv-site-nav__drawer-links {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    padding: 8px var(--bv-container-px) 6px;\n  }\n  .bv-nav-link {\n    width: 100%;\n    flex: none;\n    justify-content: flex-start;\n    padding: 12px 14px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    border-radius: var(--bv-radius);\n  }\n  .bv-nav-link span { display: inline; }\n  .bv-nav-link i {\n    width: 20px;\n    text-align: center;\n    font-size: 0.9rem;\n  }\n\n  .bv-site-nav__drawer-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 0;\n    padding: 8px var(--bv-container-px) 25px;\n    border-top: 1px solid var(--bv-line-soft);\n  }\n\n  .bv-user-menu--mobile {\n    border: none;\n    border-radius: 0;\n    margin-bottom: 0;\n    box-shadow: none;\n  }\n\n  .bv-site-nav__drawer-footer {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n\n  .bv-drawer-footer-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    min-height: 36px;\n    padding: 8px 10px;\n    border-radius: var(--bv-radius);\n    border: 1px solid var(--bv-line);\n    background: #fff;\n    font-family: var(--bv-font-body);\n    font-size: 0.75rem;\n    font-weight: 600;\n    line-height: 1;\n    text-decoration: none;\n    cursor: pointer;\n    transition:\n      background var(--bv-dur) var(--bv-ease),\n      border-color var(--bv-dur) var(--bv-ease),\n      color var(--bv-dur) var(--bv-ease);\n  }\n\n  .bv-drawer-footer-btn i {\n    font-size: 0.72rem;\n    flex-shrink: 0;\n  }\n\n  .bv-drawer-footer-btn span {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .bv-drawer-footer-btn--login {\n    color: var(--bv-primary-800);\n    border-color: var(--bv-primary-line);\n    background: var(--bv-primary-50);\n  }\n\n  .bv-drawer-footer-btn--login:hover {\n    background: #fff;\n    border-color: var(--bv-primary);\n  }\n\n  .bv-drawer-footer-btn--logout {\n    color: #dc2626;\n    border-color: rgba(239, 68, 68, 0.2);\n    background: #fef2f2;\n  }\n\n  .bv-drawer-footer-btn--logout:hover {\n    background: #fee2e2;\n    border-color: rgba(239, 68, 68, 0.35);\n  }\n\n  .bv-drawer-footer-btn--list {\n    color: var(--bv-primary-800);\n    border-color: var(--bv-primary-line);\n    background: var(--bv-bg-soft);\n  }\n\n  .bv-drawer-footer-btn--list:hover {\n    background: var(--bv-primary-50);\n    border-color: var(--bv-primary);\n    color: var(--bv-primary-800);\n  }\n}\n\n@media (max-width: 600px) {\n  .bv-site-nav-wrap {\n    padding: 0 12px;\n  }\n\n  .bv-site-nav {\n    padding: 6px 0;\n    column-gap: 8px;\n    min-height: 56px;\n  }\n\n  .bv-brand__logo {\n    width: clamp(120px, 44vw, 168px);\n    max-height: 70px;\n    height: auto;\n  }\n\n  .bv-mobile-toggle {\n    width: 36px;\n    height: 36px;\n    font-size: 0.85rem;\n  }\n\n  .bv-login-btn--bar {\n    padding: 5px 6px 5px 5px;\n  }\n\n  .bv-site-nav__drawer {\n    left: -12px;\n    right: -12px;\n  }\n\n  .bv-site-nav__drawer-links {\n    padding-inline: 12px;\n  }\n\n  .bv-site-nav__drawer-actions {\n    padding-inline: 12px;\n  }\n\n  .bv-drawer-footer-btn {\n    min-height: 34px;\n    padding: 7px 8px;\n    font-size: 0.7rem;\n    gap: 5px;\n  }\n\n  .bv-nav-link {\n    padding: 11px 12px;\n    font-size: 0.875rem;\n  }\n}\n\n/* ===== LEGACY SUPPORT (header used elsewhere in site) ============ */\n.search-box { position: relative; }\n.suggestionList {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  background: #fff;\n  border-radius: var(--bv-radius);\n  box-shadow: var(--bv-shadow);\n  padding: 8px;\n}\n.search-box .form-control:focus {\n  box-shadow: none !important;\n  border-color: var(--bv-line) !important;\n}\n.search-box .input-group-text,\n.search-box .form-control {\n  border: 0 !important;\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
